import { Subject } from 'rxjs';

export abstract class RestoreBackupSelectBaseComponent {
    public abstract onDataLoaded: Subject<Uint8Array>;
}
